import { Schema } from "effect";

// 抽奖次数（spins）奖励规则，按 bot 隔离存 bot_instance.reward_rules（jsonb）。
// 三条规则：邀请下级首充、每日首充签到、充值（满阈值额外）。详见 docs/06-domain-rules.md。

const NonNegInt = Schema.Int.pipe(Schema.greaterThanOrEqualTo(0));
const NonNegNumber = Schema.Number.pipe(Schema.greaterThanOrEqualTo(0));
const PosNumber = Schema.Number.pipe(Schema.greaterThan(0));

export const RewardRules = Schema.Struct({
  invite: Schema.Struct({
    enabled: Schema.Boolean,
    spins: NonNegInt,
    // 下级首笔 approved 充值金额 >= 此值才给邀请人发券；0 = 不限金额。
    minDeposit: NonNegNumber,
  }),
  checkin: Schema.Struct({
    enabled: Schema.Boolean,
    spins: NonNegInt,
    // 点击「签到」任务跳的 URL。空字符串 = 回退到 bot.invite_site_url 站点。
    url: Schema.String,
  }),
  deposit: Schema.Struct({
    enabled: Schema.Boolean,
    baseSpins: NonNegInt,
    threshold: PosNumber,
    bonusSpins: NonNegInt,
    // 点击「充值」任务跳的 URL。空字符串 = 回退到 bot.invite_site_url 站点。
    url: Schema.String,
  }),
});
export type RewardRules = Schema.Schema.Type<typeof RewardRules>;

export const DEFAULT_REWARD_RULES: RewardRules = {
  invite: { enabled: true, spins: 1, minDeposit: 0 },
  checkin: { enabled: true, spins: 1, url: "" },
  deposit: { enabled: true, baseSpins: 1, threshold: 500, bonusSpins: 1, url: "" },
};
